export default "__VITE_ASSET__e198d441__"